import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { keys, isObject } from 'lodash';

import { getPaylateData } from '../../store/selectors/order';
import { goToOrderPageAction } from '../../store/actions/order';
import Popup from '../Popup';

const popupCls = 'lt-paylate-popup';

const popupClassNames = {
  modal: popupCls,
  closeButton: 'lt-modal-popup__close',
  overlay: `${popupCls}__overlay`,
};

class PaylatePopup extends React.PureComponent {
  constructor(props) {
    super(props);

    this.formRef = React.createRef();
    this.state = { isShown: true };
  }

  static getFormValue(value) {
    if (isObject(value)) {
      return encodeURIComponent(JSON.stringify(value));
    }
    return value;
  }

  componentDidUpdate(prevProps) {
    const { paylateData } = this.props;

    if (paylateData && !prevProps.paylateData) {
      this.formRef.current.submit();
    }
  }

  render() {
    const { goToOrderPage, paylateData } = this.props;

    if (!paylateData) {
      return null;
    }

    const { id, redirect, name, data } = paylateData;

    const { isShown } = this.state;

    return (
      <Popup
        classNames={popupClassNames}
        open={isShown}
        closeOnEsc={false}
        closeOnOverlayClick={false}
        onClose={goToOrderPage}
      >
        <form target={id} action={redirect} method="post" ref={this.formRef}>
          {keys(data).map((key) => (
            <input
              type="hidden"
              key={key}
              name={key}
              value={PaylatePopup.getFormValue(data[key])}
            />
          ))}
        </form>
        <iframe name={id} title={name} width="100%" height="100%" />
      </Popup>
    );
  }
}

PaylatePopup.defaultProps = {
  paylateData: null,
};
PaylatePopup.propTypes = {
  paylateData: PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    redirect: PropTypes.string.isRequired,
    data: PropTypes.shape({}).isRequired,
  }),
  goToOrderPage: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  paylateData: getPaylateData(state),
});

const mapDispatchToProps = (dispatch) => ({
  goToOrderPage: () => dispatch(goToOrderPageAction()),
});

export default connect(mapStateToProps, mapDispatchToProps)(PaylatePopup);
